import ApiClient from "../ApiClient";

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  timeZone: "UTC",
});

function normalizeAccountValue(value) {
  if (value == null || value === "") return "-";
  return value;
}

function formatAccountDate(value) {
  if (!value || value === "-") return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return dateFormatter.format(date);
}

function normalizeAccount(account, index = 0) {
  const primaryId = account?.id ?? account?.Id;
  const accountIdentifier = account?.accountId ?? account?.AccountId;
  const fallbackKey = [
    account?.accountName ?? account?.AccountName ?? account?.company,
    account?.accountDomainName ?? account?.AccountDomainName ?? account?.domain,
    account?.activeFrom ?? account?.ActiveFrom,
    account?.activeTo ?? account?.ActiveTo,
    account?.revenue ?? account?.Revenue,
    index,
  ]
    .filter((value) => value != null && value !== "")
    .join("-");

  return {
    rowKey:
      primaryId ?? accountIdentifier ?? fallbackKey ?? `account-${index + 1}`,
    company: normalizeAccountValue(
      account?.Company ??
        account?.company ??
        account?.AccountName ??
        account?.accountName ??
        account?.Name ??
        account?.name,
    ),
    domain: normalizeAccountValue(
      account?.Domain ??
        account?.domain ??
        account?.accountDomainName ??
        account?.AccountDomainName ??
        account?.Website ??
        account?.website ??
        account?.WebSite ??
        account?.AccountDomain ??
        account?.accountDomain,
    ),
    activeFrom: formatAccountDate(
      account?.activeFrom ?? account?.ActiveFrom ?? account?.activeFromDate,
    ),
    activeTo: formatAccountDate(
      account?.activeTo ?? account?.ActiveTo ?? account?.activeToDate,
    ),
    revenue: normalizeAccountValue(
      account?.Revenue ??
        account?.revenue ??
        account?.AnnualRevenue ??
        account?.annualRevenue ??
        account?.Turnover ??
        account?.turnover,
    ),
  };
}

function normalizeCursorResponse(response) {
  const payload = response?.data?.data ?? response?.data ?? {};
  const accountItems =
    payload?.accountDetails ??
    payload?.accounts ??
    payload?.items ??
    payload?.data ??
    payload?.records ??
    [];

  return {
    data: Array.isArray(accountItems)
      ? accountItems.map((account, index) => normalizeAccount(account, index))
      : [],
    nextCursor:
      payload?.nextCursor ??
      payload?.cursor ??
      payload?.pagination?.nextCursor ??
      null,
  };
}

const AccountsService = {
  async getAccountsCursor({ limit = 20, cursor = null, search = "" } = {}) {
    const response = await ApiClient.get(`/Account/accounts-cursor`, {
      params: {
        limit,
        ...(cursor ? { cursor } : {}),
        ...(search ? { search } : {}),
      },
    });

    return normalizeCursorResponse(response);
  },
};

export default AccountsService;
